import React, { useState } from "react";
import Linkify from 'react-linkify';
import CommentBox from "../CommentBox";
import "./index.css";

interface SiteCommentInputProps {
  comment: any;
}

const SiteComment = ({
  comment
}: SiteCommentInputProps) => {
  const [displayMode, setDisplayMode] = useState<string>('view_mode');
  const [commentData, setCommentData] = useState<any>({
    ...comment,
  });

  const onCommentSaved = (commentAfterSaved:any) => {
    setCommentData({
      ...commentData,
      content: commentAfterSaved.content,
    });
    setDisplayMode('view_mode');
  }

  const usernameToDisplay = `${commentData.created_by?.first_name} ${commentData.created_by?.last_name}`;
  return (
    <div style={styles.container}>
      <div>
        <span style={styles.username}>{usernameToDisplay}</span>
        <span style={styles.createdDate}>{commentData.created_on_formatted}</span>
        <span style={styles.editedLabel}>{commentData.has_edited && '(Đã chỉnh sửa)'}</span>
      </div>
      {displayMode === 'view_mode' &&
        <div>
          <div style={styles.commentContentContainer}>
            <Linkify>
              <p style={styles.commentContentContent}>{commentData.content}</p>
            </Linkify>
          </div>
          <div style={styles.commentControlsContainer}>
            {commentData.permissions?.can_edit &&
              <span
                style={styles.commentControlButton}
                onClick={() => setDisplayMode('edit_mode')}
              >Sửa</span>
            }
          </div>
        </div>
      }
      {displayMode === 'edit_mode' &&
        <div style={styles.commentBoxDiv}>
          <CommentBox
            sitePlanningSelectionAreaId={commentData.site_planning_selection_area_id}
            comment={commentData}
            onCommentSaved={onCommentSaved}
            onCancelClicked={() => setDisplayMode('view_mode')}
          />
        </div>
      }
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: 'var(--color-line-light)',
    borderRadius: 6,
    padding: 12,
    marginTop: 12,
  },
  username: {
    fontSize: 14,
    fontWeight: 700,
  },
  createdDate: {
    fontSize: 12,
    color: 'var(--color-muted)',
    marginLeft: 12,
  },
  editedLabel: {
    fontSize: 12,
    color: 'var(--color-muted)',
    marginLeft: 4,
  },
  commentContentContainer: {
    marginTop: 6,
  },
  commentControlsContainer: {
    paddingTop: 6,
    display: 'flex',
    justifyContent: 'flex-end',
  } as React.CSSProperties,
  commentContentContent: {
    whiteSpace: 'pre-line',
    wordWrap: 'break-word',
  } as React.CSSProperties,
  commentControlButton: {
    fontSize: 14,
    fontWeight: 700,
    color: 'var(--color-muted)',
    cursor: 'pointer',
  },
  commentBoxDiv: {
    marginTop: 6,
  },
};

export default SiteComment;
